<div class="flex flex-col text-center justify-center h-full">
    <ng-container *ngIf="availablePlans$ | async as plans">
        <ng-container *ngIf="intentSource === 'BOTH'; else singleIntentSource">
            <ng-container *ngIf="plans.predictiveIntent && plans.bombora; else singlePlanOrNone">
                <h5 class="pb-4">You have no PredictiveIntent topics set up on your<br /> account. Set up your topics to get started.</h5>
            </ng-container>
            <ng-template #singlePlanOrNone>
                <h5 class="pb-4" *ngIf="plans.predictiveIntent">You have no PredictiveIntent topics set up on your<br /> account. Set up your topics to get started.</h5>
                <h5 class="pb-4" *ngIf="plans.bombora">You have no Bombora Intent topics set up on your<br /> account. Set up your topics to get started.</h5>
                <h5 class="pb-4" *ngIf="!plans.predictiveIntent && !plans.bombora">You have no PredictiveIntent topics set up on your<br /> account. Set up your topics to get started.</h5>
            </ng-template>
        </ng-container>

        <ng-template #singleIntentSource>
            <h5 class="pb-4" *ngIf="intentSource === 'PREDICTIVEINTENT'">You have no PredictiveIntent topics set up on your<br /> account. Set up your topics to get started.</h5>
            <h5 class="pb-4" *ngIf="intentSource === 'BOMBORAINTENT'">You have no Bombora Intent topics set up on your<br /> account. Set up your topics to get started.</h5>
        </ng-template>
    </ng-container>

    <div class="text-center">
        <button [disabled]="disabled" type="button" matButton="filled" (click)="redirectToIntentSettings()">Add Topics</button>
    </div>
</div>
